<template>
	<div class="widget" v-html="html"></div>
</template>

<script>
export default {
	props: {
		id: { type: Number, required: true }
	},
	created() {
		this.keyword = window.config.keyword;
	},
	mounted() {
		this.$store.dispatch('fetchHTMLWidget', this.id);
	},
	watch: {
		id: {
			immediate: true,
			handler(id) {
				this.$store.dispatch('fetchHTMLWidget', this.id);
			}
		}
	},
	computed: {
		html() {
			return this.$store.getters.getHTMLWidgetForId(this.id);
		}
	}
};
</script>

<style lang="scss">
.widget {
	overflow: hidden;
	img {
		max-width: 100% !important;
	}
}
</style>
